/**
 * @file: MaintenancePlanSettingsChangedBody.tsx
 *
 * `OrgMaintenancePlanSettingsChanged` — alert toggles on a plan
 * detail flipped. Shows one chip per flipped flag (only flags the
 * payload reports as non-null).
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgMaintenancePlanSettingsChangedFeedPayload } from '@euler/model/feed';
import { formatDateTime } from '@euler/utils/formatters/datetime';
import { FC } from 'react';
import { View } from 'react-native';
import { Chip, LabelRow, TitleText } from './common/primitives';

export const MaintenancePlanSettingsChangedBody: FC<{
  p: OrgMaintenancePlanSettingsChangedFeedPayload;
}> = ({ p }) => {
  const { rpx } = useResponsiveContext();
  const subjectName = p.planDetail
    ? p.planDetail.customAlertSubjectName ?? p.planDetail.name
    : '维保计划';
  return (
    <View>
      <TitleText>{subjectName} 提醒设置变更</TitleText>
      <View
        css={`
          margin-top: ${rpx(8)}px;
          flex-direction: row;
          flex-wrap: wrap;
        `}
      >
        {p.alertEnabled != null ? (
          <View style={{ marginRight: rpx(6), marginBottom: rpx(6) }}>
            <Chip
              text={`内部提醒${p.alertEnabled ? '已开启' : '已关闭'}`}
              color={p.alertEnabled ? '#34c759' : '#8e8e93'}
            />
          </View>
        ) : null}
        {p.customerAlertEnabled != null ? (
          <View style={{ marginRight: rpx(6), marginBottom: rpx(6) }}>
            <Chip
              text={`车主提醒${p.customerAlertEnabled ? '已开启' : '已关闭'}`}
              color={p.customerAlertEnabled ? '#34c759' : '#8e8e93'}
            />
          </View>
        ) : null}
      </View>
      {p.planDetail?.isAlertEnabled && p.planDetail.nextAlertTime ? (
        <LabelRow
          label="下次提醒"
          value={formatDateTime(p.planDetail.nextAlertTime)}
        />
      ) : null}
      {p.planDetail?.isAlertEnabledForCustomer &&
      p.planDetail.nextAlertTimeForCustomer ? (
        <LabelRow
          label="客户提醒"
          value={formatDateTime(p.planDetail.nextAlertTimeForCustomer)}
        />
      ) : null}
    </View>
  );
};
